import PubSub from "underpub-js";

var NavigationBar = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-NavigationBar',
	};

	$.extend(true, this.options, options);

};

NavigationBar.prototype.init = function() {

	var self = this;

};

export default NavigationBar;
